import * as React from "react"

const SvgPersonAdd = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M18.5 11h-2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15.5 10q0-.425.287-.713A.97.97 0 0 1 16.5 9h2V7q0-.425.288-.713A.97.97 0 0 1 19.5 6a.97.97 0 0 1 .712.287q.288.288.288.713v2h2a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712A.97.97 0 0 1 22.5 11h-2v2q0 .424-.288.712A.97.97 0 0 1 19.5 14a.97.97 0 0 1-.712-.288A.97.97 0 0 1 18.5 13zm-9 1q-1.65 0-2.825-1.175T5.5 8c0-1.649.392-2.042 1.175-2.825Q7.85 4 9.5 4c1.65 0 2.042.392 2.825 1.175Q13.5 6.35 13.5 8c0 1.65-.392 2.041-1.175 2.825Q11.15 12 9.5 12m-8 6v-.8q0-.85.438-1.563A2.9 2.9 0 0 1 3.1 14.55a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 9.5 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087T17.5 17.2v.8q0 .825-.587 1.412A1.93 1.93 0 0 1 15.5 20h-12q-.824 0-1.413-.588A1.93 1.93 0 0 1 1.5 18m2 0h12v-.8a.97.97 0 0 0-.5-.85 13 13 0 0 0-2.725-1.013 11.6 11.6 0 0 0-5.55 0A13 13 0 0 0 4 16.35a.97.97 0 0 0-.5.85zm6-8q.825 0 1.412-.588Q11.5 8.825 11.5 8t-.588-1.413A1.93 1.93 0 0 0 9.5 6q-.825 0-1.412.587A1.93 1.93 0 0 0 7.5 8q0 .825.588 1.412Q8.675 10 9.5 10" />
  </svg>
)
export default SvgPersonAdd
